import React from 'react';

const SlideLayout = ({ 
  children, 
  className = '', 
  centered = false,
  maxWidth = '5xl'
}) => {
  const maxWidthClasses = {
    'sm': 'max-w-sm',
    'md': 'max-w-md',
    'lg': 'max-w-lg',
    'xl': 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    'full': 'max-w-full',
  };

  return (
    <div className={`slide active min-h-screen w-full flex flex-col ${centered ? 'justify-center items-center' : 'justify-start pt-24 md:pt-28'} px-6 md:px-12 lg:px-20 pb-24 ${className}`}>
      <div className={`w-full ${maxWidthClasses[maxWidth]} ${centered ? 'text-center' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export const SlideTitle = ({ children, className = '', subtitle = null }) => (
  <div className={`mb-8 md:mb-12 ${className}`}>
    <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
      {children}
    </h1>
    {subtitle && (
      <p className="mt-4 text-base md:text-lg text-muted-foreground max-w-3xl">
        {subtitle}
      </p>
    )}
  </div>
);

export const SlideContent = ({ children, className = '' }) => (
  <div className={`stagger-children ${className}`}>
    {children}
  </div>
);

export const SlideBadge = ({ children, variant = 'primary' }) => {
  const variants = {
    primary: 'tech-badge',
    secondary: 'tech-badge secondary',
    accent: 'tech-badge accent',
  };
  
  return <span className={variants[variant]}>{children}</span>;
};

export default SlideLayout;
